export const isNullOrUndefined = (value: unknown): value is undefined | null => {
    return value === undefined || value === null
}

export const deepClone = <T>(target: T): T => {
    if (target === null) {
        return target
    }
    if (target instanceof Date) {
        return new Date(target.getTime()) as any
    }

    if (Array.isArray(target)) {
        return ([...target] as any[]).map((n: any) => deepClone<any>(n)) as any
    }

    if (typeof target === 'object') {
        const cp = { ...(target as Record<string, any>) } as Record<string, any>
        Object.keys(cp).forEach((k) => {
            cp[k] = deepClone<any>(cp[k])
        })
        return cp as T
    }
    return target
}
export const isObject = (obj: unknown): obj is Record<string, unknown> =>
    obj !== null && !!obj && typeof obj === 'object' && !Array.isArray(obj)

export const isMobile = () => {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i, /mobile/i]
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem)
    })
}
